import React from 'react';
import { useTranslation } from '~/dependencies';
import { NewSession } from '~/components/ActiveCall/types';
import { IconPause, IconPlay } from '~/assets/svgIcons';
import { ReactSVG } from './styles';

type HoldToggleButtonProps = {
  onClick: (session: NewSession, callStatus: string) => void;
  session: NewSession;
};

/**
 * Component resposible to handler HOLD and UNHOLD display for active calls
 */
const HoldToggle = ({ onClick, session }: HoldToggleButtonProps) => {
  const { answered, hold: isHold } = session;

  const { t } = useTranslation();

  function clickHandler(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    onClick(session, isHold ? 'bring-forward' : 'put-on-hold');
  }

  return (
    <button
      type="button"
      title={
        isHold
          ? t('components.activeCalls.btn.unhold')
          : t('components.activeCalls.btn.hold')
      }
      disabled={!answered}
      onClick={clickHandler}>
      <ReactSVG src={isHold ? IconPlay : IconPause} selected={isHold} />
    </button>
  );
};

export default HoldToggle;
